import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, Fragment as _Fragment, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import { ref, computed } from 'vue';
import LoginDialog from '@/venit/components/cortona-venit/components/login/LoginDialog.vue';
import { useAccountStore } from '@/stores/account';


export default /*@__PURE__*/_defineComponent({
  __name: 'LoginButton',
  props: {
    size: { default: 'large' }
  },
  setup(__props: any) {



const accountStore = useAccountStore();

const showDialog = ref(false);
const loginInProgress = ref(false);

const isLoggedIn = computed(() => accountStore.authenticated);

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!isLoggedIn.value && !loginInProgress.value)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives((_openBlock(), _createBlock(_component_v_btn, {
            icon: "",
            onClick: _cache[0] || (_cache[0] = ($event: any) => {
          showDialog.value = true;
          loginInProgress.value = true;
        })
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, {
                class: _normalizeClass(__props.size)
              }, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-account-off", -1 /* CACHED */)
                ]))]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["class"])
            ]),
            _: 1 /* STABLE */
          })), [
            [
              _directive_tooltip,
              _ctx.$t('profile.name'),
              void 0,
              { "bottom-end": true }
            ]
          ]),
          _createVNode(LoginDialog, {
            show: showDialog.value,
            "onUpdate:show": _cache[1] || (_cache[1] = ($event: any) => ((showDialog).value = $event)),
            onLoggedIn: _cache[2] || (_cache[2] = ($event: any) => (loginInProgress.value = false))
          }, null, 8 /* PROPS */, ["show"])
        ], 64 /* STABLE_FRAGMENT */))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})